// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  signInWithEmailAndPassword, 
  sendPasswordResetEmail,
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // ➕ neu
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBDojdlUabIMYuntHoBXQw1BFsGeJCuuG4",
  authDomain: "pbv1-63198.firebaseapp.com",
  projectId: "pbv1-63198",
  storageBucket: "pbv1-63198.firebasestorage.app",
  messagingSenderId: "596771719569",
  appId: "1:596771719569:web:55b7b9f3cb65f773213230",
  measurementId: "G-L35K7XQCQV"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db, signInWithEmailAndPassword, sendPasswordResetEmail, setPersistence, browserLocalPersistence, browserSessionPersistence };
